import request from '@/utils/request'
import {
  NetworkpointsQuery,
  LogsQuery,
  SubmitFaultBill,
  LogItem,
  BillsQuery,
  NetworkpointItem,
  reportDetailQuery,
  FaultReportDetail,
} from '@/types/fault'
import { PageResult } from '@/types/public'
import { formatRequestByParantheses, getEntryInfo } from '@/utils/index'

export function GetNetworkpoints(query: NetworkpointsQuery): Promise<PageResult> {
  const url = getEntryInfo().isFromMemberUnToken
    ? '/api/external/applets/repair_warehouses'
    : '/api/agri/common/repair_warehouses'
  return request.get(url, { params: query })
}
export function GetNewNetworkpoints(query: NetworkpointsQuery): Promise<PageResult> {
  const url = getEntryInfo().isFromMemberUnToken
    ? '/api/external/applets/agri_warehouses'
    : '/api/agri/common/agri_warehouses'
  return request.get(url, { params: query })
}

export function GetLogs(query: LogsQuery): Promise<LogItem[]> {
  return request.get('/api-protection/uav_logs', { params: query })
}

export function SaveFaultBill(query: SubmitFaultBill[]): Promise<string> {
  return request.post('/api/agri/after_sales/apply', query)
}
export function GetFaultBills(query: BillsQuery): Promise<PageResult> {
  return request.get('/api/agri/after_sales', { params: query })
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getServiceDetail(guid: string) {
  return request.get(`/api/agri/after_sales/${guid}`)
}

export function GetNetworkpointDetail(
  guid: string,
  query: { type: string; lng: number; lat: number }
): Promise<NetworkpointItem> {
  const url = getEntryInfo().isFromMemberUnToken
    ? `/api/external/applets/repair_warehouses/${guid}`
    : `/api/agri/common/repair_warehouses/${guid}`
  console.log('url', url)
  return request.get(url, { params: query })
}

export function getFaultReportDetail(query: reportDetailQuery): Promise<FaultReportDetail> {
  const url = '/api/app/after_sales_services/responsibilities/{guid}/pdf'
  const formatUrl = formatRequestByParantheses(url, { guid: query.guid })
  return request.get(formatUrl)
}
